import React from "react"
import styled from 'styled-components';

const ColorLogo = styled.svg.attrs(({ fillColor }) => ({
  fill: fillColor || "white",
}))`
  * {
    fill: ${props => props.fill};
  }
`

const Logo = ({ className, fillColor }) => (
  <ColorLogo className={className} fillColor={fillColor} xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 31.6 31.6">
    <path d="M20.8 19.3c4.4-3.5 4.4-3.5 2.6-6.8 -1.8-3.3-8.5-4.4-1.1-9.8C16.8-0.8 11 2.9 11.7 3.9c0.8 2.9-3.6 7.3-3.6 7.3s0.6 5.3 0.4 5.9 -1.4 6.1-2.2 8.6C5.6 28.1 9.2 27.9 9.5 29.4c0.3 1.5 8.5 1.2 8.3-0.5 0.1-3.1 6.1-7.9 6.8-7.8s-1.8 4.1-1.8 4.1l8.5 0V14.6C31.3 14.6 25.3 22 20.8 19.3z"/>
    <path d="M20.3 7.8c1.6 0.8 4.1 3.9 5.2 6 1.1 2.1-1.1 3.6-2.7 5 3.4 1.2 9.4-5.9 8.8-9.1 -0.5-3.7-7.9-6.8-8.6-6.3C22.4 3.9 19.6 5.8 20.3 7.8z"/>
    <path d="M8 9.9c0 0 3.3-4 2.8-6C4.6-0.6-6.3 16.8 4.7 15.9 2.6 11.5 8 9.9 8 9.9z"/>
  </ColorLogo>
)

export default Logo